(function () {
  class SimpleCalendarFilter_Select extends HTMLElement {
    static get observedAttributes() {
      return ["attribute", "calendar"];
    }

    constructor() {
      super();
      this.hasInitiated = false;

      this.addEventListener("change", function (e) {

        this.calendar.dataStore["filter"][this.getAttribute("attribute")] =
          this.querySelector("select").value;
        this.calendar.buildCalendar();
      });
    }

    connectedCallback() {
      this.calendar = this.getConnectedCalendar();

      if (this.calendar) {

        this.builder = this.calendar.builder;
        this.parseTemplate = this.calendar.parseTemplate;

        this.calendar.addEventFilter(
          `filter-basic-select-${this.getAttribute("attribute")}`,
          this.filter,
          {
            attribute: this.getAttribute("attribute"),
            calendar: this.calendar,
          }
        );

        this.buildSelector();
        this.hasInitiated = true;
      }
    }

    attributeChangedCallback(attrName, oldVal, newVal) {
      if (this.hasInitiated) {
        this.buildSelector();
      }
    }

    buildSelector() {
      // Get all param values
      let properties = this.calendar.getTransposedEventProperties();
      let options = "";

      if (this.hasAttribute("attribute")) {
        const attr = this.getAttribute("attribute");

        if (
          typeof properties === "object" &&
          typeof properties[attr] !== undefined
        ) {

          if (this.hasAttribute("name")) {
            // ${ typeof this.calendar.dataStore['filter'][ attr ] !== 'undefined' ? '' : ' selected' }

            options = `<option value="">${this.getAttribute("name")}</option>`;
          }

          let filtersTemp = [];

          let filtersListSorted = properties[attr];

          if (attr === 'title') filtersListSorted.sort();
          for (let i in filtersListSorted) {
            if (typeof filtersListSorted[i] !== "string") {
              if (filtersListSorted[i] !== undefined) {
                filtersListSorted[i].forEach((ele) => {
                  if (!filtersTemp.includes(ele.name)) {
                    options += this.parseTemplate("filterOption", {
                      option: ele.name,
                      selected:
                        typeof this.calendar.dataStore["filter"][attr] !==
                          "undefined" &&
                          filtersListSorted.some(
                            (e) =>
                              ele.name === this.calendar.dataStore["filter"][attr]
                          )
                          ? true
                          : false,
                    });

                  }

                  filtersTemp.push(ele.name);
                });
              }
            } else if (
              typeof this.calendar.dataStore["filter"][attr] !== undefined
            ) {

              const decodeHtmlCharCodes = str =>
                str.replace(/(&#(\d+);)/g, (match, capture, charCode) =>
                  String.fromCharCode(charCode)).replaceAll('&amp;', '&');
              options += this.parseTemplate("filterOption", {
                option: filtersListSorted[i],
                selected:
                  typeof this.calendar.dataStore["filter"][attr] !==
                    "undefined" &&
                    decodeHtmlCharCodes(filtersListSorted[i]) ===
                    this.calendar.dataStore["filter"][attr]
                    ? true
                    : false,
              });
            }
          }

          this.builder(
            this,
            this.parseTemplate("filterInput", {
              options: options,
            })
          );
        }
      }
    }

    filter(events) {
      const attr = this.data.attribute;

      const decodeHtmlCharCodes = str =>
        str.replace(/(&#(\d+);)/g, (match, capture, charCode) =>
          String.fromCharCode(charCode)).replaceAll('&amp;', '&');

      let filteredEvents = events.filter((item) => {
        if (typeof item[attr] === "object")
          return (
            !this.data.calendar.dataStore["filter"][attr] ||
            item[attr].some(
              (e) => e.name === this.data.calendar.dataStore["filter"][attr]
            )
          );
        else {
          return (
            !this.data.calendar.dataStore["filter"][attr] ||
            decodeHtmlCharCodes(item[attr]) === this.data.calendar.dataStore["filter"][attr]
          );
        }
      });

      return filteredEvents;
    }

    getConnectedCalendar() {
    }

    /**
     * getLocale
     * Gets the current language to use for this component
     * @param {String} customLocale what locale we should use
     * @returns locale
     */
    getLocale(customLocale = false) {
      let locale = this.getAttribute("locale");
      return this.calendar.getLocale(locale ?? false);
    }
  }

  customElements.define(
    "simple-calendar-filter-select",
    SimpleCalendarFilter_Select
  );
})();
